export default {
    template: /* html */`
        <div class="nx-spinner__container">
            <i
                class="fa fa-spinner nx-spinner"
                aria-hidden="true"
            />
        </div>
    `,
};
